import { Text } from '@chakra-ui/react';
import { TooltipComponentProps, TooltipTypeEnum } from '@components/map/tooltips/tooltip.types';

function PerimeterPortalLabelTooltip({ data }: Readonly<TooltipComponentProps<TooltipTypeEnum.PERIMETER_PORTAL>>) {
  return <Text textStyle="md">{data}</Text>;
}

export default PerimeterPortalLabelTooltip;
